import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getQuizzesRequest,
  getQuizRequest,
  postQuizRequest,
  patchQuizRequest,
  deleteQuizRequest,
} from './api';

const fetchQuizzes = createAsyncThunk(
  'quiz/fetchQuizzes',
  async (params, { rejectWithValue }) => {
    try {
      const res = await getQuizzesRequest(params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

const fetchQuiz = createAsyncThunk(
  'quiz/fetchQuiz',
  async (quizId, { rejectWithValue }) => {
    try {
      const res = await getQuizRequest(quizId);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

const createQuiz = createAsyncThunk(
  'quiz/createQuiz',
  async (data, { rejectWithValue }) => {
    try {
      const res = await postQuizRequest(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

const updateQuiz = createAsyncThunk(
  'quiz/updateQuiz',
  async ({ data, quizId }, { rejectWithValue }) => {
    try {
      const res = await patchQuizRequest({ data, quizId });
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

const deleteQuiz = createAsyncThunk(
  'quiz/deleteQuiz',
  async (quizId, { rejectWithValue }) => {
    try {
      const res = await deleteQuizRequest(quizId);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

export { fetchQuizzes, fetchQuiz, createQuiz, updateQuiz, deleteQuiz };
